module.exports = __webpack_public_path__ + "google-analytics-logo-aa159b367317225d0ac1d26dc760d13b.webp";